import  { useEffect,React,useState, useRef } from 'react';
import { Box } from '@mui/material';
import { Editor, loader } from "@monaco-editor/react";
import LangSwitch from './LangSwitch';


const EditorWindow = ({ height, editorRef,handleMount, languageChange,codeTemplates}) => {

  const [language, setLanguage] = useState("python");  
  const [code, setCode] = useState(codeTemplates.python);

  useEffect(() => {
    loader.init().then(monaco => {
      monaco.editor.defineTheme('custom-dark', {
        base: 'vs-dark',
        inherit: true,
        rules: [],
        colors: {
          'editor.background': '#181719',
        }
      });
    });    
  }, []);

  
 
  const handleLanguageChange = (newLanguage) => {
    setLanguage(newLanguage);
    console.log("language", newLanguage);
    setCode(codeTemplates[newLanguage]);
    languageChange(newLanguage)
  };
    

  return (
    <Box>
      {/* <LangSwitch language={language} onSelect={handleLanguageChange} /> */}
      <Editor
        height={height}
        language={language}        
        theme="custom-dark"
        ref={editorRef}
        onMount={handleMount}        
        value={code} 
        options={{
            fontSize: 16,
            padding: { top: 15, bottom: 0 },  
            minimap: { enabled: false },  
        }}      
      />
    </Box>
  );
}

export default EditorWindow;